import { Box } from "@mui/material";
import { useLocation } from "react-router-dom";
import pathRoutes from "routes/pathRoutes";

const ContentLayout = ({ children }) => {
  const location = useLocation();
  return (
    <Box
      sx={({ functions: { pxToRem }, palette }) => ({
        marginTop:
          location.pathname === pathRoutes.extra.mbsBirthday26
            ? 0
            : pxToRem(72),
        backgroundColor: palette.background.bgBase,
        height:
          location.pathname === pathRoutes.extra.mbsBirthday26
            ? "100vh"
            : `calc(100vh - ${pxToRem(72)})`,
        WebkitBoxOrient: "vertical",
        overflow: "auto",
        scrollbarGutter: "stable",
      })}
    >
      {children}
    </Box>
  );
};

export default ContentLayout;
